import { render } from "./GrandPrix.vue?vue&type=template&id=772c51c4&scoped=true"
import script from "./GrandPrix.vue?vue&type=script&lang=js"
export * from "./GrandPrix.vue?vue&type=script&lang=js"

import "./GrandPrix.vue?vue&type=style&index=0&id=772c51c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772c51c4"]])

export default __exports__